import React, { lazy, Suspense } from 'react';
export const SECTION_ID = 'characters';
import { staticImageAssets } from 'js/constants/Paths';
import { useSelector } from 'react-redux';

const Carousel = lazy(() => import('js/components/carousel/Carousel'));

import SvgTextureLineLong from 'js/components/svg/Svg.texture_line_long';

// import selectors
import { getCarouselCharacters } from 'js/store/characters/Characters.selectors';

import ContentItemCharactersBlock from 'js/components/content-item/ContentItem.characters-block.jsx';

const Footprints = () => {
  return (
    <figure className={`header-region__footprints`}>
      <picture>
        <source
          media="(max-width:768px)"
          srcSet={`${staticImageAssets('images/static/welcome_footprints_mobile.png')}`}
        />
        <img
          src={staticImageAssets('images/static/welcome_footprints_desktop.png')}
          alt="Bird footprints"
          title="Bird footprints"
        />
      </picture>
    </figure>
  );
};

const CarouselItems = () => {
  const carouselCharacters = useSelector((state) => {
    return getCarouselCharacters(state);
  });

  return carouselCharacters.map((item) => {
    const { id } = item;
    return (
      <div key={id} className="header-region__slide">
        <ContentItemCharactersBlock item={item} carousel={true} />
      </div>
    );
  });
};

const HeaderRegionCharacters = ({ title, description }) => {
  const slideRef = React.useRef(null);
  const prevRef = React.useRef(null);
  const nextRef = React.useRef(null);

  const hideArrows = () => {
    prevRef.current.style.display = 'none';
    nextRef.current.style.display = 'none';
  };

  const updateArrows = () => {
    if (slideRef.current && slideRef.current.swiper) {
      if (slideRef.current.swiper.isBeginning) {
        nextRef.current.style.display = 'flex';
        prevRef.current.style.display = 'none';

        return;
      }

      if (slideRef.current.swiper.isEnd) {
        nextRef.current.style.display = 'none';
        prevRef.current.style.display = 'flex';
        return;
      }
      nextRef.current.style.display = 'flex';
      prevRef.current.style.display = 'flex';
    }
  };

  const handleResize = () => {
    if (slideRef.current && slideRef.current.swiper) {
      if (window.innerWidth < 768) {
        slideRef.current.swiper.slides?.length > 1 ? updateArrows() : hideArrows();
      } else {
        slideRef.current.swiper.slides?.length > 3 ? updateArrows() : hideArrows();
      }
    }
  };

  const attachedArrows = () => {
    if (slideRef.current && slideRef.current.swiper) {
      slideRef.current.swiper.on('resize', handleResize);
      handleResize();
    }

    return () => {
      if (slideRef.current && slideRef.current.swiper) {
        slideRef.current.swiper.off('resize', handleResize);
      }
    };
  };

  return (
    <section id={SECTION_ID} className={`header-region header-region--${SECTION_ID}`}>
      <div className="container">
        <div className={`header-region__middle-section`} style={{ position: 'relative', margin: '50px 0' }}>
          <button
            className="carousel__nav carousel__nav--prev"
            style={{ display: 'none' }}
            onClick={() => {
              slideRef.current.swiper.slidePrev();
              updateArrows();
            }}
            ref={prevRef}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="15" viewBox="0 0 23 15" fill="none">
              <path
                d="M3.51001 11.73L11.5 3.73999L19.49 11.73"
                stroke="#7D5D84"
                strokeWidth="6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <Suspense fallback={<div>Loading Content...</div>}>
            <Carousel ref={slideRef} spaceBetween={0} onloadCallback={attachedArrows}>
              {CarouselItems()}
            </Carousel>
          </Suspense>

          <button
            className="carousel__nav carousel__nav--next"
            style={{ display: 'none' }}
            onClick={() => {
              slideRef.current.swiper.slideNext();
              updateArrows();
            }}
            ref={nextRef}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="15" viewBox="0 0 23 15" fill="none">
              <path
                d="M3.51001 11.73L11.5 3.73999L19.49 11.73"
                stroke="#7D5D84"
                strokeWidth="6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <div className={`header-region__lower-section`}>
          <div className={`header-region__characters-details`}>
            <SvgTextureLineLong color={'#fff'} />
            <h1>{title}</h1>
            <h2>{description}</h2>
          </div>
        </div>
      </div>
      <Footprints />
    </section>
  );
};

export default HeaderRegionCharacters;
